import styled from 'styled-components';

export const OldAuditEntryText = styled.div<{
  completed: boolean;
  color: string;
  reverseColor?: boolean;
}>`
  color: ${(props) =>
    props.reverseColor
      ? props.theme.atlas.semantic.color.type.default
      : props.theme.atlas.semantic.color.surface.default};
  font-size: 12px;

  & > span {
    color: ${(props) =>
      props.completed
        ? props.color
        : props.theme.atlas.semantic.color.status.error.default};
  }
`;

export const OldAuditEntryContainer = styled.div`
  display: flex;
  border-radius: 9;
`;

export const OldAuditEntryVerticalLine = styled.div`
  border-left: 3px solid grey;
  height: 40px;
  margin-left: 23px;
`;

export const OldAuditEntryContent = styled.div`
  color: grey;
  line-height: 1.5;
  font-size: 11px;
`;

export const OldAuditEntryIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: grey;
  margin-right: 15px;

  & > img {
    height: 50px;
  }
`;

export const OldAuditEntryIcon = styled.div`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.atlas.semantic.color.type.default};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
`;
